












































































































































































import { Component, Vue } from 'vue-property-decorator'
import BlocoDeCodigo from './BlocoDeCodigo.vue'
import { FindWebhookUseCase } from '@/usecases'
import { docDoEvento, montarEnvelopeDeExemploFormatado } from '@/shareds/exemplosDeWebhook'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'

interface ExemploParaExibir {
	chave: string
	descricao: string
	origem: string
	quandoDispara: string
	corpo: string
}

@Component({
	components: { BlocoDeCodigo },
})
export default class DocumentacaoDeWebhook extends Vue {
	painelAberto: number[] = [0]
	aba = 0
	exemplos: ExemploParaExibir[] = []
	findUseCase = new FindWebhookUseCase()

	envelopeGenerico = JSON.stringify(
		{
			evento: '<chave-do-evento>',
			enviadoEm: '<data/hora ISO-8601 do envio>',
			conta: '<uuid da sua conta>',
			dados: { '...': 'específico de cada evento, veja os exemplos abaixo' },
		},
		null,
		2,
	)

	exemploNode = `const crypto = require('crypto')

function validarAssinatura(corpoBruto, headerSignature, secret) {
  const esperada = 'sha256=' + crypto
    .createHmac('sha256', secret)
    .update(corpoBruto, 'utf8')
    .digest('hex')

  return crypto.timingSafeEqual(Buffer.from(esperada), Buffer.from(headerSignature))
}`

	exemploPhp = `function validarAssinatura(string $corpoBruto, string $headerSignature, string $secret): bool {
    $esperada = 'sha256=' . hash_hmac('sha256', $corpoBruto, $secret);
    return hash_equals($esperada, $headerSignature);
}`

	montarExemplo(chave: string, descricao: string): ExemploParaExibir {
		const doc = docDoEvento(chave)
		return {
			chave,
			descricao,
			origem: doc ? doc.origem : '',
			quandoDispara: doc ? doc.quandoDispara : '',
			corpo: montarEnvelopeDeExemploFormatado(chave),
		}
	}

	async created() {
		try {
			const disponiveis = await this.findUseCase.listarEventosDisponiveis()
			this.exemplos = [
				...disponiveis.map(evento => this.montarExemplo(evento.chave, evento.descricao)),
				this.montarExemplo('webhook.teste', 'Evento de teste manual'),
			]
		} catch (error: any) {
			AlertModule.setError(error)
		}
	}
}
